import locale from "@packs/locale/locale"
import store from '../../../../edit/store'
import('./position_component.css')
export default function PositionComponent(opts){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this

    this.generate = () =>{
        console.log(store.getProgressBarOptions());
        let current_position = store.getProgressBarOptionsNestedProp('options.position')
        if(!current_position){
            current_position = 'top'
            store.setProgressBarOptionsNestedProp('options.position', current_position)
        }
        elements.container = this.createElement('div')
        elements.label = this.createElement('label', '', 'Posição')
        elements.select = this.createElement('select', 'progress-position-component')
        {
            //criando lista de options do select
            ['top', 'bottom'].forEach(position=>{
                $(elements.select).append(`<option value=${position}>${locale.t(position)}</option>`)
            })
            
            //definindo o valor inicial do select
            elements.select.value = current_position

            $(elements.select).on('change', () =>{
                //ao alterar, atualizando objeto com as propriedades da progress bar
                store.setProgressBarOptionsNestedProp('options.position', elements.select.value)
            })
        }
        

        $(elements.container).append(elements.label,elements.select)
        $(container).append(elements.container)
    }

    this.update = () =>{
        
    }
}

PositionComponent.prototype = Object.create(BaseConstructor.prototype)